module.exports = __webpack_public_path__ + "static/media/ic_Quiz-Incorrect.475cc137.png";